import { z } from 'zod'
import { baseModelShape } from '../baseModel'

export const BBMS = 'BBMS'
export const EveryAction = 'EveryAction'
export const SpringBoard = 'SpringBoard'
export const EngagingNetwork = 'EngagingNetwork'
export const NAACPCustomAPI = 'NAACPCustomAPI'
export const BBMSCheckout = 'BBMSCheckout'
export const BBMSCheckoutInline = 'BBMSCheckoutInline'
export const BBMSSkyPayments = 'BBMSSkyPayments'

export const paymentProviders = {
  1: BBMS,
  2: EveryAction,
  3: SpringBoard,
  4: EngagingNetwork,
  5: NAACPCustomAPI,
  6: BBMSCheckout,
  7: BBMSCheckoutInline,
  8: BBMSSkyPayments,
}

export const npoShape = {
  id: z.string().uuid(),
  name: z.string(),
  logo: z.string().url().nullable(),
  donationFormOpacity: z.number().int().min(0).max(100).optional(),
}

export const answerShape = {
  id: z.string().uuid(),
  text: z.string(),
}
